import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Container, Row, Col, Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { addBillExternal, getBillExternals, getBillExternal, editBillExternal, removeBillExternal, addDocument, deleteDocument } from '../../../actions/billExternalsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import { getBusinesses } from '../../../actions/businessesActions'
import BillExternalForm from '../../../components/forms/BillExternalForm'
import BillExternalDocumentsForm from '../../../components/forms/BillExternalDocumentsForm'

export default function BillExternals() {
    const { t } = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()
    const {client} = useAuth()

    const {billExternals, billExternal, resultbillExternal, loading} = useSelector(state=>state.billExternals)
    const {businesses} = useSelector(state=>state.businesses)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)
    const [modalShowDocument, setModalShowDocument] = useState(false)
    const [formStateDocument, setFormStateDocument] = useState({})

    useEffect(() => {
        if(client){
            dispatch(getBillExternals())
            dispatch(getBusinesses('provider'))
        }
    },[dispatch, t, client])

    useEffect(() => {
        // Ejecuta lógica cuando la URL cambia
        if(client){
            dispatch(getBillExternals())
            dispatch(getBusinesses('provider'))
        }
    }, [location])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            business: null,
            date: new Date(),
            number: 0,
            concept: '',
            quantity: 0,
            accounted: false
        })
        setModalShow(true)
    }

    const selectBillExternal = (billExternal) => {
        dispatch(getBillExternal(billExternal._id))
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleCheckboxChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.checked
        })
    }

    const handleSelectChange = (element, attribute)=>{
        if(attribute === 'business'){
            setFormState({
                ...formState,
                [attribute]: element.value
            })
        }else{
            setFormState({
                ...formState,
                [element.target.name]: element.target.value
            })
        }
    }

    useEffect(()=>{
        if (billExternal) {
            setFormState({
                id: billExternal._id,
                business: billExternal.business._id,
                date: billExternal.date,
                number: billExternal.number,
                concept: billExternal.concept,
                quantity: billExternal.quantity,
                accounted: billExternal.accounted
            })
        }
    }, [billExternal])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsRegistering(true);
    
        if (isAddingOrEditing === 'editing') {
            dispatch(editBillExternal(formState, formState.id));
        } else {
            dispatch(addBillExternal(formState));
        }
    
        setIsRegistering(false);
    }

    const selectBillExternalDocument = (business) => {
        setFormStateDocument({
            businessId: business._id,
            businessName: business.name,
            documentDescription: '',
            documentUrl: '',
            documents:business.documents
        })
        setModalShowDocument(true)
    }

    const handleInputDocumentChange = ({target})=>{
        setFormStateDocument({
            ...formStateDocument,
            [target.name]: target.value
        })
    }

    const handleFileChange = ({target})=>{
        setFormStateDocument({
            ...formStateDocument,
            [target.name]: target.files[0]
        })
    }
    
    const handleDeleteDocument = async(document, business) => {
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text:  t('admin.billExternals.areyousuredeletedocument')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteDocument(document, business))
            }
        })
    }

    const handleSubmitDocument= async(e) => {
        e.preventDefault()
        setIsRegistering(true)
        dispatch(addDocument(formStateDocument, formStateDocument.businessId))
        setIsRegistering(false)
    }

    const handleDeleteBillExternals = async(e, billExternalId) => {
        e.preventDefault()
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.accept'),
            denyButtonText: t('global.cancel'),
            icon: 'warning',
            html: t('admin.billExternals.areyousureremove')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeBillExternal(billExternalId))
                setModalShow(false)
            }
        })
    }

    useEffect(() => {
        if(resultbillExternal){
            let resultbillExternalTemp = resultbillExternal
            dispatch({ type: 'BILLEXTERNAL_RESET_RESULT'})
            switch (resultbillExternalTemp) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.billExternals.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'successedit':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.billExternals.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setModalShowDocument(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'successDeleteDocument':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.billExternals.deletesuccessDocument')
                    }).then(() => {
                        setModalShowDocument(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'deletesuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.billExternals.deletesuccess')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break
                default:
                    break
            }
        }
    // eslint-disable-next-line
    }, [resultbillExternal])

    const columnsBillExternals = [
        {
            name: t('admin.billExternals.date'),
            width: '180px',
            cell: billExternal =>
                <div className='cursor' onClick={() => selectBillExternal(billExternal)}>
                    {new Date(billExternal.date).toLocaleDateString('es-ES', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        timeZone: 'Europe/Madrid'
                    })}
                </div>,
            selector: (billExternal) => billExternal.date,
            sortable: true,
        },{
            name: t('admin.billExternals.number'),
            width: '180px',
            cell: billExternal =>
                <div className='cursor' onClick={() => selectBillExternal(billExternal)}>
                    {billExternal.number}
                </div>,
            selector: (billExternal) => billExternal.number,
            sortable: true,
        },{
            name: t('admin.billExternals.business'),
            left: true,
            cell: billExternal =>
                <div className='cursor' onClick={() => selectBillExternal(billExternal)}>
                    {billExternal.business?.identifier} - {billExternal.business?.name}
                </div>,
            selector: (billExternal) => `${billExternal.business?.identifier} - ${billExternal.business?.name}`,
            sortable: true,
        },{
            name: `${t('admin.billExternals.total')} kg`,
            right: true,
            cell: billExternal =>
                <div className='cursor' onClick={() => selectBillExternal(billExternal)}>
                    {billExternal.quantity}
                </div>,
            selector: (billExternal) => billExternal.quantity,
            sortable: true,
        },{
            name: '',
            width: '180px',
            center: true,
            cell: billExternal =>
                <div className='d-flex justify-content-between'>
                    <div className='cursor mx-2' onClick={() => selectBillExternal(billExternal)}>
                        <i className='fas fa-pencil'></i>
                    </div>
                    <div className='cursor mx-2' onClick={(e) => handleDeleteBillExternals(e, billExternal._id)}>
                        <i className='fas fa-trash'></i>
                    </div>
                    <div className='cursor' onClick={() => selectBillExternalDocument(billExternal)}>
                        <i className='fas fa-paperclip'></i> {billExternal.documents?.length > 0 ? billExternal.documents.length : ''}
                    </div>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col className='text-center'>
                    <h1>{t('admin.billExternals.billExternals')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        {t('admin.billExternals.createbillExternal')}
                    </Button>
                </Col>
            </Row>

            {
                loading
                    ?
                        <Loader/>
                    :

                        <Row>
                            <Col>
                            {billExternals?.length > 0
                                ?
                                    <CustomDataTable columns={columnsBillExternals} data={billExternals} exportable={false} printable={false}/>
                                :
                                    <h4 className='mt-4 text-center mb-5'>{t('admin.billExternals.thereisnotbillExternals')}</h4>
                            }
                            </Col>
                        </Row>

            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.billExternals.billExternal')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BillExternalForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        handleCheckboxChange={handleCheckboxChange}
                        handleSelectChange={handleSelectChange}
                        handleDeleteBillExternals={handleDeleteBillExternals}
                        businesses={businesses}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
            <Modal
                show={modalShowDocument}
                onHide={() => setModalShowDocument(false)}
                aria-labelledby="contained-modal-title-vcenter-clip"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter-clip">
                        <h2>{t('admin.businesses.documents')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BillExternalDocumentsForm
                        state={formStateDocument}
                        handleInputChange={handleInputDocumentChange}
                        handleFileChange={handleFileChange}
                        handleDeleteDocument={handleDeleteDocument}
                        submit={handleSubmitDocument}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}